export const API_URLS = {
  // Login APIs
  ADMIN_LOGIN_APIURL: 'User/admin-login',
  STUDENT_LOGIN_APIURL: 'User/student-login',
  TEACHER_LOGIN_APIURL: 'Teacher/teacher-login',
  EMPLOYEE_LOGIN_APIURL: 'User/employee-login',
  PARENT_LOGIN_APIURL: 'User/parent-login',
  AUTH_LOGIN_APIURL: 'Authorization/LoginPost',

  // Registration
  SIGNUP_APIURL: 'Authorization/Registration',

  // Forgot Password APIs
  EMPLOYEE_FORGOT_PASSWORD_APIURL: 'User/employee-forgot-password',
  ADMIN_FORGOT_PASSWORD_APIURL: 'User/admin-forgot-password',
  ADMIN_RESET_EXPIRED_PASSWORD_APIURL: 'User/admin-reset-expired-password',
  ADMIN_RESET_EXPIRED_PASSWORD_OTP_APIURL: 'User/admin-reset-expired-password-otp',
  STUDENT_FORGOT_PASSWORD_APIURL: 'User/student-forgot-password',
  PARENT_FORGOT_PASSWORD_APIURL: 'User/parent-forgot-password',

  // Change Password APIs
  EMPLOYEE_CHANGE_PASSWORD_APIURL: 'User/DefaultPasswordChange',
  ADMIN_CHANGE_PASSWORD_APIURL: 'User/DefaultPasswordChange',
  STUDENT_CHANGE_PASSWORD_APIURL: 'User/DefaultPasswordChange',
  PARENT_CHANGE_PASSWORD_APIURL: 'User/DefaultPasswordChange',

  // OTP Verify APIs
  EMPLOYEE_VERIFY_OTP_APIURL: 'User/employee-verify-otp',
  ADMIN_VERIFY_OTP_APIURL: 'User/admin-verify-otp',
  STUDENT_VERIFY_OTP_APIURL: 'User/student-verify-otp',
  PARENT_VERIFY_OTP_APIURL: 'User/parent-verify-otp',

  DEFAULTCHANGEPASSWORD_VERIFY_OTP_APIURL: 'User/DefaultPasswordChange-VerfiyOTP',

  //Other APIs
  GET_USER_PROFILE_APIURL: 'auth/me',
  ADD_STUDENT_APIURL: 'api/AddStudent',
  ADMIN_AREA_APIURL: 'Authrization/admin-area',
  REFRESH_TOKEN_API: 'User/refresh-token',
  REFRESH_COMMON_TOKEN_API: 'User/common-refresh-token-roleName',


  // Logout APIs
  ADMIN_LOGOUT_APIURL: 'User/admin-logout',
  STUDENT_LOGOUT_APIURL: 'User/student-logout',
  EMPLOYEE_LOGOUT_APIURL: 'User/employee-logout',
  PARENT_LOGOUT_APIURL: 'User/parent-logout',

  //Stream Section & Sub Stream Section
  ADD_STREAM_MASTERTABLE: 'ClassSection/addStream/MasterTable',
  ADD_SUB_STREAM_MASTERTABLE: 'ClassSection/addSubStream/MasterTable',
  GET_ALL_STREAM_MASTERTABLE: 'ClassSection/getAllStream/MasterTable',
  GET_ALL_SUB_STREAM_MASTERTABLE: 'ClassSection/getAllSubStreams/MasterTable',
  GET_ALL_CLASS_MASTERTABLE: 'ClassSection/getAllClasses/MasterTable',
  GET_ALL_MASTER_CLASS_MASTERTABLE: 'ClassSection/getAllMasterClasses/MasterTable',
  GET_ALL_CLASS_SECTION_MASTERTABLE: 'ClassSection/getAllSections/MasterTable',
  UPDATE_STREAM_MASTERTABLE: 'ClassSection/UpdateStream/MasterTable',
  DELETE_SUBSTREAM_MASTERTABLE: 'ClassSection/DeleteSubStreamMasterTable',
  UPDATE_SUB_STREAM_MASTERTABLE: 'ClassSection/updateSubstream/MasterTable',
  DELETE_SECTION_MASTERTABLE: 'ClassSection/DeleteSectionMasterTable',
  GET_ALL_SCHOOL_MAPPED_CLASSES: 'ClassSection/SchoolClasses/Get',
  DELETE_SUBJECT_MASTERTABLE: 'ClassSection/DeleteSubjectMasterTable',
  CHECK_SUBJECT_MARKS_EXIST: 'ClassSection/CheckSubjectMarksExist',
  CHECK_CLASS_MARKS_EXIST: 'ClassSection/CheckClassMarksExist',

  //Subject Section &  Subject Section
  GET_ALL_SUBJECT_MASTERTABLE: 'ClassSection/getAllSubjects/MasterTable',
  ADD_SUBJECT_MASTERTABLE: 'ClassSection/addSubject/MasterTable',
  UPDATE_SUBJECT_MASTERTABLE: 'ClassSection/updateSubject/MasterTable',
  UPDATE_CLASS_MASTERTABLE: 'ClassSection/updateClass/MasterTable',
  ADD_CLASS_MASTERTABLE: 'ClassSection/addClass/MasterTable',
  UPDATE_SECTION_MASTERTABLE: 'ClassSection/updateSection/MasterTable',
  DELETE_Class_MASTERTABLE: 'ClassSection/DeleteClassMasterTable',
  DELETE_STREAM_MASTERTABLE: 'ClassSection/DeleteStreamMasterTable',
  ADD_SECTION_MASTERTABLE: 'ClassSection/addSection/MasterTable',
  GET_ALL_CBSE_SUBJECT_TYPE: 'ClassSection/GetAllCBSESubjectType',
  GET_ALL_EXAM_COMPONENT: 'ClassSection/GetAllExamComponent',
  GET_ALL_RESULT_TYPE: 'ClassSection/GetAllResultType',

  //ClassScetion APIs

  // CREATE_CLASS_MAPPING_APIURL: "ClassSection/UpdateClasssStreamSubStreamSectionMapping",
  CREATE_CLASS_MAPPING_APIURL: 'ClassSection/UpdateClassSectionStreamSubStreamMapping',
  GETALL_CLASS_MAPPING_APIURL: 'ClassSection/GetAllClassesWithDetails',
  // GETALL_CLASS_STREAM_SSTREAM_SEC_MAPPING_APIURL: 'ClassSection/GetAllClassesWithSecStrSubs',
  GET_CLASS_SECTION_CHECKBOX_APIURL: 'ClassSection/GetAllClassesWithSectionsMapping',
  GETALL_FREQUENCY: 'FeeManagement/FeeFrequencyMap/GetAll',
  //PeriodSection APIs

  CREATE_PERIOD_APIURL: 'ClassSection/addPeriod',
  GETALL_PERIOD_APIURL: 'ClassSection/GetAllPeriod',
  UPDATEPERIOD_APIURL: 'ClassSection/UpdatePeriod',
  DELETE_PERIOD_TABLE: 'ClassSection/DeletePeriod',

  //get All ClassPeriod TeacherscheduleList APIs

  // CREATE_CLASS_MAPPING_APIURL: "ClassSection/UpdateClasssStreamSubStreamSectionMapping",
  ADD_OR_UPDATE_ASSIGN_CLASS_PERIOD_TO_TEACHER:
    'ClassSection/UpdateOrInsertAssignClasssPeriodToTeacher',
  DELETE_ASSIGN_CLASS_PERIOD_TO_TEACHER: 'ClassSection/DeleteAssignClasssPeriodToTeacher',
  GET_ALL_ASSIGN_CLASS_PERIOD_TO_TEACHER: 'ClassSection/GetAllAssignClasssPeriodToTeacher',
  GET_BY_ID_ASSIGN_CLASS_PERIOD_TO_TEACHER: 'ClassSection/GetByIDAssignClasssPeriodToTeacher',
  //Attendence Mark APIs

  ADD_STUDENTATTENDENCEMARK_APIURL: 'Reports/addStudentAttendenceMark',
  UPDATE_STUDENTATTENDENCEMARK_APIURL: 'Reports/UpdateStudentAttendenceMark',
  INSERT_UPDATE_ATTENDANCE_STUDENT: 'Reports/InsertUpdateStudentAttendance',
  GETALL_STUDENTATTENDENCEMARK_APIURL: 'Reports/GetAllStudentAttendenceMarkList',
  GETALL_STUDENTATTENDENCEMARKLIST_APIURL: 'Reports/GetAllMarkedAttendanceStudentsReport',
  GETALL_STUDENT_ATTENDANCE_BYDATE: 'Reports/GetAllStudentsAttendanceByDate',


  GET_ALL_CLASS_SUBJECT_MAPPING_APIURL: 'ClassSection/GetsubjectMappedlist',
  GET_ALL_CLASS_TEACHER_SUBJECT_MAPPING_APIURL: 'Reports/GetClassTeacherSubjectMapping',
  GET_ALL_SUBJECTS_TEACHER_APIURL: 'EmployeeManage/subject-based-teachers',


  GET_ALL_TEACHER_APIURL: "EmployeeManage/teacher",
  GET_TEACHER_ASSIGNED_CLASS_SECTION_LIST_APIURL: "EmployeeManage/getAll/TeacherAssignedClassSectionList",
  ADD_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL: "EmployeeManage/TeacherAssigned/classSection/insertAndUpdate",
  UPDATE_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL: "EmployeeManage/TeacherAssigned/classSection/insertAndUpdate",
  DELETE_TEACHER_ASSIGNED_CLASS_SECTION_APIURL: `EmployeeManage/delete/TeachersAssignedClassSection`,

  ADMIN_GET_ALL_ROLES: 'AdminDashboard/GetAllRoles',
  COMMUNICATION_MESSAGE_ALL_SENT: 'AdminDashboard/communication-messages/all-sent',
  ADMIN_COMMUNICATION_MESSAGE: 'AdminDashboard/Insert/communication-messages',

  //FeeMaster Section APIs

  ADD_FEETYPE_APIURL: 'FeeManagement/fee-type/add',
  GETALL_FEETYPE_APIURL: 'FeeManagement/fee-type/get-all',
  UPDATE_FEETYPE_APIURL: 'FeeManagement/fee-type/update',
  DELETE_FEETYPE_APIURL: 'FeeManagement/fee-type/delete',

  //FeeFrequency Section APIs

  ADD_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/add',
  GETALL_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/get-all',
  UPDATE_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/update',
  DELETE_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/delete',
  GET_ALL_FEE_TYPE_APIURL: 'FeeManagement/fee-type/get-all',
  GET_ALL_FEE_FREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/get-all',
  GET_ALL_FEE_FREQUENCY_DUEDATES_APIURL: 'FeeManagement/Fee-Frequency/NameWithDueDates',

  GET_ALL_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Get',
  GET_FEE_STRUCTURE_BY_CLASS_COMBO_APIURL: 'FeeManagement/FeeStructureByClassCombo/Get',
  ADD_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Add',
  CREATE_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/DynamicAdd',
  UPDATE_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Update',
  DELETE_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Delete',
  ADD_NOTICE_BY_ROLE: "NoticeDashboard/Add/NoticeByRole",
  UPDATE_NOTICE_BY_ROLE: "NoticeDashboard/update/NoticeByRole",
  DELETE_NOTICE_BY_ROLE: "NoticeDashboard/delete/NoticeDetails/NoticeId",
  ROLE_NOTIFICATION_BY_NOTICEID: "NoticeDashboard/RoleNoticeDetailsBy/NoticeId",
  ALL_NOTICE_LIST: "NoticeDashboard/allnoticeList",
  GET_NOTICE_CATEGORY_LIST: "NoticeDashboard/NoticeCategoryList",


  GET_ALL_ROLES: 'AdminDashboard/GetAllRoles',
  GET_ALL_MENU_LIST: 'AdminDashboard/GetAllMenuList',
  GET_INSERT_AND_UPDATE_ROLE_ROUTE: 'AdminDashboard/insertAndUpdate/RoleRoute',
  GET_ROUTE_DETAIL_BY_ROLE_ID: 'AdminDashboard/GetRouteDetailsByRoleId',

  SIDEBAR_CONFIGURATION_GET_ALL_LABEL: 'SchoolDashboard/SidebarMenuLabel/GetAll',
  SIDEBAR_CONFIGURATION_INSERT_OR_UPDATE: 'SchoolDashboard/SidebarMenuLabel/InsertOrUpdate',
  // FEES COLLECTION  APIS

  GETALL_FEECOLLECTION_APIURL: "FeeManagement/FeeStructure/Get",
  UPDATE_ALL_FEE_COLLECTION_APIURL: "FeeManagement/FeeCollection/InsertOrUpdate",
  GET_ALL_FEE_COLLECTION_APIURL: "FeeManagement/FeeCollection/Get",
  DELETE_FEE_COLLECTION_BY_ID_APIURL: "FeeManagement/FeeCollection/Delete",
  GETALL_SUBJECTLIST: "Student/studentSubjectList",
  GET_ADMIN_DASHBOARD_DATA: 'AdminDashboard/GetAdminDashboardData',
  GET_ALL_COLLECTION_STATUS_LIST: "FeeManagement/FeeCollection/get-all",
  INSERT_OR_UPDATE_FEE_REMINDER: 'FeeManagement/FeeReminder/InsertOrUpdate',
  GET_ALL_FEE_TYPES: 'FeeManagement/fee-type/get-all',
  GET_ALL_FEE_REMINDERS: 'FeeManagement/FeeReminder/GetAll',
  GET_ALL_FEE_REMINDERS_EMAILS: 'FeeManagement/FeeReminderEmailTo/GetAll',
  DELETE_FEE_REMINDER: 'FeeManagement/FeeReminder/Delete',
  INSERT_OR_UPDATE_FEE_REMINDER_MESSAGE: 'FeeManagement/FeeReminderMessage/InsertOrUpdate',
  GET_ALL_FEE_REMINDERSMESSAGE: 'FeeManagement/FeeReminderMessage/GetAll',
  DELETE_FEE_REMINDER_MESSAGE: 'FeeManagement/FeeReminderMessage/Delete',
  GET_ALL_FEES_COLLECTION_CHECK_STATUS_LIST: 'Student/student-fee-details',
  GET_ALL_FEES_VIEW_COLLECTION_CHECK_STATUS_LIST: 'Student/student-fee-view-details',
  GET_ALL_STUDENT_FEE_DETAILS_LIST: 'Student/studentFeesViewDetails',
  GET_ALL_STUDENT_FEE_QRCODE_DETAILS_LIST: 'Student/studentQrCodeFeesViewDetails',
  TRANSPORT_MANAGEMENT_VECHICLE_MASTER_GET_LIST: 'TransportManage/VehicleMaster_GetList',

  GET_ALL_CALENDER_DATA: 'SchoolDashboard/SchoolCalender/GetAll',
  THEME_INSERT_AND_UPDATE: 'AdminDashboard/insertAndUpdate/ThemeSetting',
  GETALL_THEME_DETAILS: 'AdminDashboard/GetThemeDetails/SchoolID',
  ADMIN_PROFILE: 'AdminDashboard/GetAdminprofile/AdminId',
  GET_INVOICE_BY_FEE_COLLECT_ID: "FeeManagement/FeeInvoice/Get",
  UPDATE_ADMIN_PROFILE: 'User/adminProfile-update',
  GET_LOGO_BASE64POST: "ClassSection/get-logoInsert-base64",
  SIDEBAR_UPDATEDMENU: 'SchoolDashboard/SidebarMenuLabel/GetAll',
  CREATE_TICKET_SUPPORT: 'AdminDashboard/CreateTicket/Support',
  GET_ALL_TICKETS_SUPPORT: 'AdminDashboard/GetAllTickets/Support',
  GET_STAFF_DETAILS: "EmployeeManage/staff/Get",
  GET_EMPLOYEE_CHANGE_PASSWORD: "User/employee-change-password",
  CREATE_EXAM: "Reports/CreateExam",
  GET_EXAM_LIST: "Reports/GetExamList",
  UPDATE_EXAM: "Reports/UpdateExam",
  DELETE_EXAM_DETAILS: "Reports/delete-ExamDetail/ExamID",
  CHECK_EXAM_MARKS_EXIST: "Reports/CheckExamMarksExist",
  INSERT_UPDATE_EXAM_PUBLISH_STATUS: "Reports/InsertUpdateExamPublishStatus",
  GET_PUBLISHED_EXAM_LIST: "Reports/GetPublishedExamList",

  GET_STUDENT_MARKSHEETS:"ReportCard/GetStudentReportCard",
  GET_STUDENT_RESULT_REPORT_CARD_MARKSHEET_SETTING_WISE:"ReportCard/GetStudentReportCardMarksheetSettingWise",
  BULK_UPDATE_MARKSHEET_ATTENDANCE: "Reports/BulkUpdateMarkSheetAttend",
  GET_ALL_TRANSPORT_FREQUENCIES: "FeeManagement/TransportFreq/MasterTable",
  // BULK_UPLOAD_STUDENT_REGISTRATION: 'Student/BulkRegistrationStudent',
  // BULK_UPLOAD_EMPLOYEE_REGISTRATION: 'EmployeeManage/BulkRegistrationEmployee',
  
  // BULK_UPLOAD_STUDENT_REGISTRATION: 'SchoolDashboard/StudentDataUpload',
  // BULK_UPLOAD_STUDENTNEW_REGISTRATION: 'SchoolDashboard/StudentDataUpload',
  BULK_UPLOAD_STUDENT_REGISTRATION: 'SchoolDashboard/StudentCommonUploadData',
  BULK_UPLOAD_STUDENTNEW_REGISTRATION: 'SchoolDashboard/StudentCommonUploadData',
  BULK_UPLOAD_EMPLOYEE_REGISTRATION: 'SchoolDashboard/EmployeeDataUpload',
  BULK_UPLOAD_STUDENT_ATTENDANCE: 'SchoolDashboard/StudentAttendanceExcelUpload',
  BULK_UPLOAD_EMPLOYEE_ATTENDANCE: 'SchoolDashboard/EmployeeAttendanceExcelUpload',

  BULK_EXCEL_SHEET_STUDENT_DOWNLOAD: 'SchoolDashboard/StudentDataDownload',
  BULK_EXCEL_SHEET_EMPLOYEE_DOWNLOAD: 'SchoolDashboard/EmployeeDataDownload',
  BULK_EXCEL_SHEET_STUDENT_ATTENDANCE_DOWNLOAD: 'SchoolDashboard/StudentAttendanceExcelDownload',
  BULK_EXCEL_SHEET_EMPLOYEE_ATTENDANCE_DOWNLOAD: 'SchoolDashboard/EmployeeAttendanceExcelDownload',

  // Leave Master Api
  GET_ALL_LEAVE_MASTER_TYPES: 'EmployeeManage/get-leave-types',
  ADD_LEAVE_MASTER_TYPES: 'EmployeeManage/add-leave-type',
  UPDATE_LEAVE_MASTER_TYPES: 'EmployeeManage/Update-leave-type',
  DELETE_LEAVE_MASTER_TYPES: 'EmployeeManage/delete-leave-type',

  // My Leave Api For Employee 
  GET_STAFF_LEAVE_BY_EMPLOYEE: 'EmployeeManage/staff-leaves/by-employee',
  ADD_STAFF_LEAVE: 'EmployeeManage/staff-leaves/add',
  UPDATE_STAFF_LEAVE: 'EmployeeManage/update-employee-leave',
  DELETE_STAFF_LEAVE: 'EmployeeManage/delete-employee-leave',

  // My Leave Api For Student
  GET_STUDENT_LEAVE_DATA: "Student/get-studentbyID-leaves",
  STUDENT_APPLY_LEAVE: "Student/Student-apply-leave",
  UPDATE_LEAVE_BY_STUDENT: 'Student/Student-update-leave',
  DELETE_LEAVE_BY_STUDENT: 'Student/Student-delete-leave',

  // Approve Request Api for Admin
  GET_ALL_EMPLOYEE_LEAVE_DATA: 'EmployeeManage/getAdmin-AllEmployeesLeaves',
  GET_ALL_STUDENT_LEAVE_DATA: 'Student/get-all-student-leaves',
  APPROVE_LEAVE_REQUEST_BY_ADMIN: "AdminDashboard/review-by-admin",
  DELETE_STUDENT_EMPLOYEE_LEAVE: "AdminDashboard/Admin-delete-leave-approval",

  // Approve Request Api for Teacher
  APPROVE_LEAVE_REQUEST_BY_TEACHER: "Student/ReviewByTeacher",
  DELETE_STUDENT_LEAVE: "Student/Student-delete-leave",


  MARK_EMPLOYEE_ATTENDANCE: 'Reports/addEmployeeMarkAttendance',
  GET_ALL_EMPLOYEE_ATTENDANCE_LIST: 'Reports/GetAllEmployeeAttendanceList',
  UPDATE_EMPLOYEE_ATTENDANCE: 'Reports/UpdateEmployeeMarkAttendance',
  STAFF_PUNCHIN_PUNCHOUT: 'Reports/Staff-PunchIn-PunchOut',
  GET_EMPLOYEE_ATTENDANCE_REPORT_LIST: 'Reports/GetEmployeeAttendanceReportList',
  CREATE_EXAM_SCHEDULE: "Reports/CreateExamSchedule",
  GET_EXAM_SCHEDULE_BY_CLASS: "Reports/GetExamScheduleByClass",
  EXAM_STATUS_UPDATE: "Reports/examStatus-Update",
  UPDATE_EXAM_SCHEDULE: "Reports/UpdateExamSchedule",
  DELETE_EXAM_SCHEDULE_DETAIL: "Reports/delete-ExamScheduleDetail",
  CREATE_HOLIDAY: "NoticeDashboard/Add/Holiday",
  UPDATE_HOLIDAY: "NoticeDashboard/Update/Holiday",
  DELETE_HOLIDAY: "NoticeDashboard/Delete/Holiday",
  GETALL_HOLIDAY: "NoticeDashboard/get-all-holidays",
  HOMEWORK_FILTER: 'Homework/GetHomeWorkDataByFilters',
  INSERT_HOMEWORKDATA: 'Homework/InsertHomework',
  HOMEWORK_EVALUATION_REPORT: 'Homework/GetHomeworkEvaluationReport',
  DELETE_HOMEWORK: 'Homework',
  ADD_UPDATE_EXAM_MARKS: 'Reports/AddOrUpdate-ExamMarks',
  GET_EXAM_MARKS_BY_CLASS: 'Reports/GetExamMarksByClass',
  GET_EXAM_RESULT_REPORT: 'Reports/GetExamResultReport',
  SAVE_HOMEWORK_EVALUATION: 'Homework/SaveHomeworkEvaluation',

  GET_STUDENT_HOMEWORKDASHBOARD_DATA: 'Homework/GetStudentHomeworkDashboard',
  CLASS_TEACHER_SUBJECT_MAPPING: 'Reports/GetClassTeacherSubjectMapping',

  // Timetable api for studentDashboard
   GET_TIMETABLE_STUDENTDASHBOARD:"Student/student-TimeTable",

GET_CLASS_WISE_FEE_REPORT:"FeeManagement/FeeCollection/class-wise-fee-report",
GET_CLASS_WISE_FEE_REPORT_SUMMERY:"FeeManagement/FeeCollection/class-wise-fee-report-summary",

  // Today Class Api For Teacher Dashboard 
   GET_TODAY_CLASSES_FOR_TEACHER:'EmployeeManage/Teacher/TodayClasses',
     SAVE_AND_UPDATE_TRANSFERHISTORY:"Student/StudentTransferHistory-SaveOrUpdate",

     // birthday reminder for Teacher Dashboard
       GET_BIRTHDAY_REMINDER_FOR_TEACHER:'EmployeeManage/Teacher/BirthdayReminders',
       STUDENT_CHANGE_PASSWORD:'User/student-change-password',
       GET_TRANSFER_HISTORY:'Student/get-transfer-history',
       GET_DEACTIVE_STUDENTS_BYID:'Student/GetDeactiveStudentDetailsById',
  
  // Route Management 
  GET_ALL_BUS_ROUTE_LIST : 'TransportManage/GetAll-BusRouteList',
  INSERT_BUS_ROUTE : 'TransportManage/insert/BusRoute',  
  UPDATE_BUS_ROUTE: 'TransportManage/update/BusRoute',
  DELETE_BUS_ROUTE: 'TransportManage/delete-BusRoute', 
  UPDATE_ROUTE_STATUS: 'TransportManage/RouteStatus-Update',
       
  // TransportManage Bus Management
  GET_ALL_DRIVER_LIST:'TransportManage/GetAll-DriverList',
  GET_ALL_HELPER_LIST:'TransportManage/GetAll-HelperList',
  INSERT_VEHICLE_DETAILS:'TransportManage/insert/VehicleDetails',
  UPDATE_VEHICLE_DETAILS:'TransportManage/update/VehicleDetails',
  GET_ALL_VECHICLE_LIST:'TransportManage/GetAll-VehicleList',
  DELETE_VECHICLE_LIST:'TransportManage/delete-VehicleDetails',
  STATUS_TOGGLE_VECHICLE:'TransportManage/Status/VehicleDetails',
GET_BUS_HISTORY: 'TransportManage/bus-history',
GET_BUS_DETAILS: 'TransportManage/bus-details',
GET_SCHOOL_LOCATION_BY_ID: 'SchoolDashboard/GetSchoolLocationById',
  // Student Transport Allocation 
  TRANSPORT_MANAGEMENT_ALL_ACTIONS: 'TransportManage/transport-management-actions',



//GatePass Master  Api

EXIT_GATE_MASTER_POST:"GateMaster/exit-gate",
EXIT_GATE_MASTER_GET:"GateMaster/exit-gate",
EXIT_GATE_MASTER_PUT:"GateMaster/exit-gate/",
EXIT_GATE_MASTER_DELETE:"GateMaster/exit-gate/",

//Visit Type GatePass
ADD_VISIT_PURPOSE:"GateMaster/visitor-type",
GET_VISIT_PURPOSE:"GateMaster/visitor-type",
DELETE_VISIT_PURPOSE:"GateMaster/visitor-type/",
UPDATE_VISIT_PURPOSE:"GateMaster/visitor-type/",

// Marks & Grading API
DIVISION_MASTER_SAVE_UPDATE_DIVISION:"DivisionMaster/save-update-division",
DIVISION_MASTER_GET_ALL_DIVISION_LIST:"DivisionMaster/GetAll-DivisionMasterList",
DIVISION_MASTER_DIVISION_STATUS_UPDATE:"DivisionMaster/DivisionStatus-Update",
DIVISION_MASTER_SAVE_UPDATE_PERCENTAGE_REMARK:"DivisionMaster/save-update-PercentageRemarksmaster",
DIVISION_MASTER_GET_ALL_PRECENTAGE_REMARK_LIST:"DivisionMaster/GetAll-PercentageRemarksmasterList",
DIVISION_MASTER_UPDATE_PRECENTAGE_REMARK:"DivisionMaster/PercentageRemarksmasterStatus-Update",
DIVISION_MASTER_SAVE_UPDATE_SUBJECT_GRADE_RANGE:"DivisionMaster/save-update-SubjectGradeRange",
DIVISION_MASTER_GET_ALL_SUBJECT_GRADE_LIST:"DivisionMaster/GetAll-SubjectGradeRangeList",
DIVISION_MASTER_UPDATE_SUBJECT_GRADE_LIST:"DivisionMaster/SubjectGradeRangeStatus-Update",
INITIATE_FLAGS:'ClassSection/Flags-Class-Initiate',

GET_ACTIVE_CLASSES_ACTIVE_STUDENTS:'ClassSection/GetActiveClasses_Student',
GET_STUDENT_FEE_STRUCTURE_SETTING: 'ClassSection/GetStudentFeeSetting',


PARENT_VISIT_STUDENT_DASH: 'User/Parent-Student-Visit',
PARENT_ADD_KID_ID: 'User/add-parent-student',
VARIFY_PARENT_ADD_KID_ID: 'User/parent-student-verify-otp',

//Gate Pass Student List
INSERT_STUDENT_GATEPASS_LIST:"GateMaster/insert/studentgatepassList",
UPDATE_STUDENT_GATEPASS_LIST:"GateMaster/update/studentgatepassList",
DELETE_STUDENT_GATEPASS_LIST:"GateMaster/delete/studentgatepass/",
GET_STUDENT_GATEPASS_LIST:"GateMaster/getallStudentGatePassList/",

//Gate  Pass Staff List

INSERT_STAFF_GATEPASS_LIST:"GateMaster/insert/gatepassstafflist",
UPDATE_STAFF_GATEPASS_LIST:"GateMaster/update/gatepassstaffList",
DELETE_STAFF_GATEPASS_LIST:"GateMaster/delete/staffgatepass/",
GET_STAFF_GATEPASS_LIST:"GateMaster/getallstaffGatePassList/",

//Gate Pass Visitor List
INSERT_VISITOR_GATEPASS_LIST:"GateMaster/insert/visitorpassList",
UPDATE_VISITOR_GATEPASS_LIST:"GateMaster/update/visitorpassList",
DELETE_VISITOR_GATEPASS_LIST:"GateMaster/delete/visitorpass/",
GET_VISITOR_GATEPASS_LIST:"GateMaster/getallVisitorPassList/",


// Host Meeting Apis 
CURD_ACTIONS_HOST_MEETING_LIST : "HostMeeting/host-meeting-curd",
TICKETS_TRACKING_ACTIONS:'AdminDashboard/Ticket-Tracking-actions',

// Parent Profile Page
GET_PARENT_DETAILS : "User/get-parent-details",
UPDATE_PARENT_DETAILS: "User/update-parent-details",
GET_ID_CARD_DETAILS_BY_ROLE:"Reports/GetIDCardDetailsByRole",
UPDATE_BULK_STUDENT_IDENTITY:"User/update-bulk-identity",

// Fee Collection And Fee Due Apis 
GET_STUDENT_FEE_COLLECTION_REPORT: "FeeManagement/FeeCollection/student-fee-collection-report",
GET_STUDENT_FEE_COLLECTION_SUMMARY: "FeeManagement/FeeCollection/student-fee-collection-summary",
GET_STUDENT_FEE_DUE_REPORT: "FeeManagement/FeeCollection/student-fee-due-report",
GET_STUDENT_FEE_DUE_SUMMARY: "FeeManagement/FeeCollection/student-fee-due-report-summary",

//Status Master
INSERT_INQUIRY_STATUS:"AdmissionInquiry/AdmissionInquiryStatus/Master",
DELETE_INQUIRY_STATUS:"AdmissionInquiry/DeleteInquiryStatusMaster",
GET_INQUIRY_STATUS:"AdmissionInquiry/Inquiry_StatusSummary",

CREATE_WHATSAPP_SETTING:"SchoolDashboard/Create/WhatsAppSettingConfig",

// Add Inquiry
INSERT_INQUIRY:"AdmissionInquiry/InsertStudentAdmissionInquiry",
GET_ADMISSIONINQUIRY_LIST:"AdmissionInquiry/StudentAdmissionInquiryList",
GET_ADMISSIONINQUIRY_DETAILS:"AdmissionInquiry/StudentAdmissionInquiryDetails",
UPDATE_ADMISSIONINQUIRY_STATUS:"AdmissionInquiry/StudentAdmissionInquiry_UpdateStatus",
UPDATE_CONVERTTOADMISSION_STATUS:"AdmissionInquiry/StudentAdmissionInquiry_UpdateStatus_Converted",
UPDATE_STUDENT_ENQUIRY_DETAILS:"AdmissionInquiry/UpdateStudentAdmissionInquiry",
GET_ROZAR_PAYMENT_GATEWAY_DATA:"SchoolDashboard/SchoolPaymentGatewayGetByID",
GET_ROZAR_PAYMENT_SAVE_UPDATE_GATEWAY:"SchoolDashboard/SchoolPaymentGateway/SaveUpdate",

// Student My Attendance Report 
GET_STUDENT_MY_ATTENDANCE_REPORT_BY_ID:"Reports/GetAllStudentAttendanceMarkListById",

// BioMetric for Student And Emplpoyee
BIOMETRIC_ALL_ACTIONS_FOR_STUDENT:"Student/RSS_StudentBioMetricConfig/Save",
BIOMETRIC_ALL_ACTIONS_FOR_EMPLOYEE:"EmployeeManage/RSS_EmployeeBioMetricConfig/Save",

UPDATE_FEE_PAYMENT_BY_PARENT_APIURL: "FeeManagement/FeeCollection/InsertOrUpdate_QrCode",

// BioMetric Register for school
GET_ALL_DEVICES_FOR_SCHOOL: "SchoolDashboard/RSS_RealTimeDeviceConfig/GetAll",
CREATE_UPDATE_DEVICE_FOR_SCHOOL : "SchoolDashboard/RSS_RealTimeDeviceConfig/Save",
DELETE_DEVICE_FOR_SCHOOL:"SchoolDashboard/RSS_RealTimeDeviceConfig/Delete",

GET_QRCODE_FEES_VIEW_COLLECTION_CHECK_STATUS_LIST: 'FeeManagement/qr-code-student-fee-view-details',

GET_QRCODE_FEES_STUDENT_DETAILS_LIST: 'FeeManagement/GetStudentsQrCodeFeeDetails',
GET_QRCODE_FEES_STUDENT_SUMMERY_LIST: 'FeeManagement/GetStudentsQrCodeFeeSummeryDetails',
APPROVE_QRCODE_FEES_STUDENT: 'FeeManagement/ApproveQrCodeFeesPayment',
REJECT_QRCODE_FEES_STUDENT: 'FeeManagement/RejectOnHoldQrCodeFeesPayment',

UPDATE_SCHOOL_QRCODE_BY_SCHOOLID: 'SchoolDashboard/UpdateSchoolQrCodeById',
DELETE_SCHOOL_QRCODE_BY_SCHOOLID: 'SchoolDashboard/DeleteSchoolQrCodeById',
GET_QR_CODE_FEE_STATUS_MASTER: 'FeeManagement/GetQrCodeFeeMaster',

ADMIN_CHANGE_PASSWORD:"User/admin-change-password",
EMPLOYEE_CHANGE_PASSWORD:"User/employee-change-password",
PARENT_CHANGE_PASSWORD:"User/parent-change-password",
STUDENT_CHANGE_PASSWORD_WITH_OTP:"User/student-change-password",
CREATE_STUDENT_FEE_SETTING:"FeeManagement/CreateStudentFeeSetting",

  //Discount Section APIs
  ADD_DISCOUNT_APIURL: 'FeeManagement/AddDiscount/MasterTable',
  GETALL_DISCOUNT_APIURL: 'FeeManagement/GetAllDiscount/MasterTable',
  UPDATE_DISCOUNT_APIURL: 'FeeManagement/UpdateDiscount/MasterTable',
  DELETE_DISCOUNT_APIURL: 'FeeManagement/DeleteDiscount/MasterTable',

  //communication modal api
  GET_ALL_PARENTS:"User/GetAllParents",
 
  // Hostel Create apis
INSERTUPDATEHOSTELCREATION :"Hostel/Hostel_SaveUpdate",
GETALLHOSTELLIST: "Hostel/GetHostelList",
DELETEHOSTEL: "Hostel/Delete_HostelDetails",
// Room type apis
ADDUPDATEROOMTYPE: "Hostel/RoomTypeMaster_SaveUpdate",
GETALLROOMTYPELIST: "Hostel/GetRoomTypeMasterList",
DELETEROOMTYPE: "Hostel/Delete_RoomDetails",
// add rooms apis
ADDUPDATEHOSTELROOM: "Hostel/HostelRoomMaster_SaveUpdate",
GETALLHOSTELROOMLIST: "Hostel/GetHostelRoomMasterList",
DELETEHOSTELROOM: "Hostel/Delete_HostelRoomDetails",
//assign hostel student
ADDUPDATEASSIGNHOSTEL: "Hostel/StudentAssignRoom", 
STATUSUPDATEASSIGNHOSTEL: "Hostel/ReleaseStudentRoom",
GETALLLISTASSIGNHOSTEL: "Hostel/GetHostelAssignmentReport",
DELETEASSIGNHOSTEL: "Hostel/Delete_StudentRoomAssignmentDetails",
GETALLHOSTELDATA: "Hostel/GetHostelDashboardSummary",

 GET_FEE_COLLECT_LIST_SUMMERY: "FeeManagement/FeeCollection/GetCollectFeeSummery",

 //class master list

 CLASSMASTERLIST:"ClassSection/GetAllPreDefineClasses",


 //Admin Dashboard graph api 
ADMINDASHBOARDGRAPHDATA:"AdminDashboard/GetAdminDashboardGraphData",

DIRECTOR_DASHBOARD_API_BINDING:"AdminDashboard/GetGroupSchoolAnalytics",

//marks and grading api url
POST_COSCHOLASTIC_MARKS_GRADING_POINT_5:"DivisionMaster/save-update-CoScholasticGradeRangePoint5",
GET_COSCHOLASTIC_MARKS_GRADING_POINT_5:"DivisionMaster/GetAll-CoScholasticGradeRangePoint5List",
UPDATE_COSCHOLASTIC_MARKS_GRADING_POINT_5:"DivisionMaster/CoScholasticGradeRangePoint5Status-Update",

POST_COSCHOLASTIC_MARKS_GRADING_POINT_3:"DivisionMaster/save-update-CoScholasticGradeRangePoint3",
GET_COSCHOLASTIC_MARKS_GRADING_POINT_3:"DivisionMaster/GetAll-CoScholasticGradeRangePoint3List",
UPDATE_COSCHOLASTIC_MARKS_GRADING_POINT_3:"DivisionMaster/CoScholasticGradeRangePoint3Status-Update",

ADD_UPDATE_CO_SCHOLASTIC_EXAM:"Reports/AddOrUpdateCoScholasticMarks",
ADD_UPDATE_CO_SCHOLASTIC_EXAM_BULK:"Reports/AddOrUpdateCoScholasticMarksBulk",

GET_CO_SCHOLASTIC_EXAM:"Reports/GetCoScholasticResultReport",
GET_CO_SCHOLASTIC_RESULT_BY_EXAM:"Reports/GetCoScholasticResultReportByExam",

// Biometric attendance Bulk upload 
BIOMETRIC_ATTENDANCE_UPPLOAD_EMPLOYEE: "SchoolDashboard/AttendanceEmployeeDymUpload",
BIOMETRIC_ATTENDANCE_UPPLOAD_STUDENT: "SchoolDashboard/AttendanceStudentDymUpload",

// Fee Fine master Api binding
  ADD_Fine_APIURL: 'FeeManagement/AddFine/MasterTable',
  GETALL_Fine_APIURL: 'FeeManagement/GetFine/MasterTable',
  UPDATE_Fine_APIURL: 'FeeManagement/UpdateFine/MasterTable',
  DELETE_Fine_APIURL: 'FeeManagement/DeleteFine/MasterTable',


//Additional subjects mapping

INSERT_UPDATE_ADDITIONAL_SUBJECT:"ClassSection/AdditionalSubject/insertAndUpdate",
DELETE_ADDITIONAL_SUBJECT:"ClassSection/DeleteAdditionalSubject",
UPDATE_ADDITIONAL_SUBJECT:"ClassSection/GetStudentsBySubjectClassSection",
GET_ADDITIONAL_SUBJECT:"ClassSection/GetStudentsBySchoolWithSubjects",
GET_ADDITIONAL_SUBJETlIST:"ClassSection/AdditionalSubjectsListBySchoolId",
GET_CLASS_STREAM_SUBSTREAMBY_SUBJECT:"ClassSection/GetClassStreamSubStreamBySubject",


// Session Setting APi url
SESSION_INSERT_UPDATE_API:"Session/Session/insertAndUpdate",
GET_SESSION_YEAR_LIST:"Session/GetSessionYearList",
GET_SESSIONYEARBUID_LIST:"Session/GetSessionYearById",
DELETE_SESSION_YEAR:"Session/DeleteSessionYear",
SESSION_YEAR_TOGGLE_STATUS:"Session/SessionYear/ToggleStatus",


//Co-Scholastic Report

GET_COSCHOLASTIC_SUBJECT_DETAILS:"Reports/GetStudentCo-ScholasticSubjectList",
UPDATE_STUDENT_FEE_STRUCTURE:"FeeManagement/UpdateFeeToStudent",
STATUS_FEE_STRUCTURE_SHOW:"FeeManagement/FeeCollection/StatusFeeStructureShow",

// Exam Mapping Api 
  ADD_EXAM_MAPPING: 'Reports/Exam-mapping/insertAndUpdate',
  GETALL_EXAM_MAPPING: 'Reports/Exam-mapping/get',
  UPDATE_EXAM_MAPPING: 'Reports/Exam-mapping/insertAndUpdate',
  DELETE_EXAM_MAPPING: 'Reports/exam-mapping/delete',
  
// Exam Bulk update mark
GETALL_MARK_BULK_UPDATE: "Reports/bulk-exam-student-marks",
INSERT_MARK_BULK_UPDATE: "Reports/AddOrUpdate-BulkExamMarks",
UPDATE_MARK_BULK_UPDATE: "Reports/AddOrUpdate-BulkExamMarks",

UPLOAD_SCHOOL_MULTIFILES: "SchoolDashboard/SchoolMultiDocumentUpload",


//Custom TimeTable
GET_DAY_LIST:"Session/GetDaysList",
ADD_CUSTOM_ADDPERIOD:"ClassSection/CustomAddPeriod",
ADD_SUBJECT_PERIOD:"ClassSection/CustomTimeTableSubjectPeriodTeacher/SaveUpdate",
DELETE_CUSTOM_PERIOD:"ClassSection/DeleteCustomPeriod",
GET_CUSTOM_TIMETABLE:"ClassSection/GetSchoolTimeTableList",
DELETE_SUBJECT_PERIOD:"ClassSection/DeleteCustomAssignClassPeriodToTeacher",
GET_CUSTOM_PERIOD:"ClassSection/GetCustomPeriodsList",

  // Create New Institute
  ADD_SCHOOL_INSTITUTE: "AddSchoolInstitute",
  GET_SCHOOL_INSTITUTE: "GetSchoolInstitute",
  UPDATE_SCHOOL_INSTITUTE: "UpdateSchoolInstitute",
  DELETE_SCHOOL_INSTITUTE: "DeleteSchoolInstitute",
  GETALL_SCHOOL_ACADEMICYEAR: 'Session/GetSessionYearList',

  UPDATE_STUDENT_STATUS_CLASS: 'SchoolDashboard/PromoteOrDemoteStudents',
  GET_ACTIVE_STUDENTS_BY_CLASSES: 'ClassSection/GetActiveStudentByClasses',

 GET_ACTIVE_ADMIN_SCHOOLS: 'AdminDashboard/GetAdminSchools',

  //  Transport Fee
  TRANSPORT_FEE_SAVE_UPDATE: 'FeeManagement/SaveUpdate_TransportFee',
  GET_TRANSPORT_FEE: 'FeeManagement/TransportFee/List',
  DELETE_TRANSPORT_FEE : 'FeeManagement/DeleteTransportFee',

  //Stop Management
  TRANSPORT_MANAGER_INSERT_STOP: 'TransportManage/insert/Stop',
  TRANSPORT_MANAGER_UPDATE_STOP: 'TransportManage/update/Stop',
  TRANSPORT_MANAGER_DELETE_STOP: 'TransportManage/delete/Stop',
  TRANSPORT_MANAGER_GET_STOP_BY_ROUTEID: 'TransportManage/get/Stop/by-route/{routeId}',
  TRANSPORT_MANAGER_GET_STOP_BY_ID: 'TransportManage/get/Stop/{id}',
  TRANSPORT_MANAGER_GET_STOP_GETALL: 'TransportManage/get/Stop/GetAll',
  TRANSPORT_MANAGER_TRANSPORT_FEE_APPLICABLE_FOR: 'TransportManage/get/TransportFee/ApplicableFor',
  TRANSPORT_MANAGER_GET_STOP_APPLICABLE_FOR: 'TransportManage/get/Stop/ApplicableFor',
  TRANSPORT_GET_ALL_FEE_TYPE : 'Hostel/GetAllFeeTypes',
  TRANSPORT_MANAGER_UPDATE_STOP_STATUS: 'TransportManage/StopStatus-Update',

 //Hostel management
 HOSTEL_ROOMTYPE_SAVEUPDATE:"Hostel/RoomType_SaveUpdate",
 HOSTEL_ROOMTYPE_DELETE:"Hostel/RoomType_Delete",
 HOSTEL_ROOMTYPE_GET:"Hostel/RoomType_List",

 HOSTEL_OCCUPANCY_SAVEUPDATE:"Hostel/Occupancy_SaveUpdate",
 HOSTEL_OCCUPANCY_GET:"Hostel/Occupancy_WithBeds",
 HOSTEL_OCCUPANCY_DELETE:"Hostel/Occupancy_Delete",

 HOSTEL_ROOM_SAVEUPDATE:"Hostel/Room_SaveUpdate",
 HOSTEL_ROOM_GET:"Hostel/Room_List",
 HOSTEL_ROOM_DELETE:"Hostel/Room_Delete",

 HOSTELFEE_SAVEUPDATE:"Hostel/HostelFee_SaveUpdate",
 HOSTELFEE_GET:"Hostel/HostelFee_List",
 HOSTELFEE_DELETE:"Hostel/Fee_Delete",
HOSTELFEE_FREQUNCYNAME:"Hostel/GetAllHostelFeeFrequncy",

ASSIGN_HOSTEL_TO_STUDENT:"Hostel/AssignRoom",
GET_ASSIGN_HOSTEL:"Hostel/RoomAssignment_List",

DELETE_ASSIGN_HOSTEL:"Hostel/RoomAssignment_Delete",

//curd of Designation master
CURD_DESIGNATION :"SchoolDashboard/SchoolDesignations_Curd",

// user assing role apis 
GET_ALL_DEFAULT_MENUS : "SchoolDashboard/GetDefaultMenus",
GET_ALL__ASSIGN_MENUS_AND_ROLES: "SchoolDashboard/GetMenusWithOverrideSchool",
INSERT_UPDATE_MENUS_TO_ROLES : "AdminDashboard/InsertOrUpdateMenuSchool",

GET_ALL_USERINFO_AND_ROLES: "AdminDashboard/GetRoleWiseUserInfo",
INSERT_UPDATE_USERINFO_ROLES : "AdminDashboard/UpdatePasswordByUserName",

// Student Bulk Edit apis
GET_ALL_STUDENT_BULK_DATA : "Student/GetStudentsForBulkEdit",
UPDATE_STUDENT_DATA: "Student/BulkEditStudents",
HOSTEL_FEETYPE:"Hostel/GetAllFeeTypes",
HOSTEL_REPORT_DETAIL:"Hostel/HostelDashboardDetails_List",

//Expense api
EXPENSE_HEAD_GET:"Expense/GetExpenses",
EXPENSE_HEAD_POST:"Expense/SaveExpense",
EXPENSE_HEAD_DELETE:"Expense/DeleteExpense",
EXPENSE_MASTER_POST:"Expense/SaveExpenseHead",
EXPENSE_MASTER_GET:"Expense/GetExpenseHeads",
EXPENSE_MASTER_DELETE:"Expense/DeleteExpenseHead",

//syllabus api url
POST_UNITMASTER:"Syllabus/SaveUnitMaster",
GET_UNITMASTER:"Syllabus/GetUnitMasterList",
DELETE_UNITMASTER:"Syllabus/DeleteUnitMaster",

//syllabus detail api url
ADD_UPDATE_BULK_SYLLABUS:"Syllabus/Syllabus_Save&UpdateBulk",
GET_BULK_SYLLABUS:"Syllabus/GetSyllabusList",
DELETE_BULK_SYLLABUS:"Syllabus/DeleteChapterAndTopic",

//get all leave for employee leave dashboard
GET_EMPLOYEE_LEAVE:"EmployeeManage/get-employee-leave-dashboard",

// Get all leave summary in approve request 
GET_ALL_LEAVE_SUMMARY: "EmployeeManage/get-employee-leaves-summary",


POSTUPDATE_PAYROLL:"Payroll/SavePayrollType",
GET_ALL_PAYROLL_TYPES:"Payroll/GetAllPayrollTypes",

DELETE_PAYROLL_TYPE:"Payroll/DeletePayrollType",

GET_WAGE_TYPE:"Payroll/GetWageType",
GET_PAY_FREQUENCY:"Payroll/GetPayFrequency",
GET_WORK_TYPE:"Payroll/GetWorkType",
GET_ALL_SHIFT:"Payroll/GetShift",
GET_ALL_ACCOUNT_TYPE:"Payroll/GetAccountType",

GET_ALL_EMPLOYEE_PAYSLIP:"Payroll/Employee_Payslip",

EMPLOYEE_PAYSLIP_PAYMENT:"Payroll/ProcessEmployeePayslipPayment",
EMPLOYEE_PAYSLIP_PAYMENT_Pay:"Payroll/PayEmployeeSalary",
EMPLOYEE_PAYSLIP_LIST:"Payroll/Employee_Payslip_List",
EMPLOYEE_BYID_PAYSLIP_LIST:"Payroll/Employee_Payslip_List_By_Filter",
EMPLOYEE_PAYSLIP_HISTORY:"Payroll/Payroll_History",

// TC Student Details Updates
SAVE_UPDATE_TC_DETAILS: "Student/StudentTransferCertificate-SaveOrUpdate",
GET_UPDATED_TC_DETAILS: "Student/GetSchoolTransferCertificateList",

//staff bulk attendance mark
GET_EMPLOYEE_DOJ_LIST:"Payroll/Employee_DOJ_List",
STAFF_DOJ_UPDATE:"Payroll/UpdateEmployeePayrollAttendance",
STAFF_ADVANCE_SALARY_UPDATE:"Payroll/UpdateEmployeeAdvanceSalary",
GET_STAFF_ADVANCE_SALARY:"Payroll/Employee_Advance_Salary_List",

NOTICE_DASHBOARD_ALL_EMPLOYEE_LIST_BY_ROLE: "NoticeDashboard/allEmployeeListByRole",
GET_ALL_USERS_BY_ROLE: "NoticeDashboard/allUserListByRole",

// Fee Due Structure Curd
CURD_FEE_DUE:"FeeManagement/Secondary/FeeStructure",

//Subject Master and mapping api
GET_SUBJECT_MASTER:"ClassSection/GetSubjectMaster",
INSERT_SUBJECTS:"ClassSection/InsertSubjectMaster",
UPDATE_SUBJECTS:"ClassSection/UpdateSubjectMaster",
DELETE_SUBJECTS:"ClassSection/DeleteSubjectMaster",

// Employee Student bulk attedance api 
INSERT_EMPLOYEE_ATTENDANCE_BULK:"Reports/addAllEmployeeAttendanceMark",
INSERT_STUDENT_ATTENDANCE_BULK:"Reports/addAllStudentAttendanceMark",


// house api url
SAVE_UPDATE_HOUSE:"House/SaveHouse",
GET_HOUSE:"House/GetHouseList",
DELETE_HOUSE:"House/DeleteHouse",
ASSIGN_HOUSE:"House/SaveHouseAssignment",
GET_ASSIGN_HOUSE_LIST:"House/GetHouseAssignmentStudents",
DELETE_ASSIGN_HOUSE_STUDENT:"House/DeleteHouseAssignmentStudent",

// Employee mark attendance
GETALL_EMPLOYEE_ATTENDANCE_BYDATE: 'Reports/GetAllEmployeesAttendanceByDate', 
INSERT_UPDATE_ATTENDANCE_EMPLOYEE: 'Reports/InsertUpdateEmployeeAttendance',

// Employee report api 
GET_EMPLOYEES_ATTENDANCE_REPORT: 'Reports/GetAllMarkedAttendanceEmployeesReport',


//student Report
GET_STUDENT_HEADER_NAME:"Student/GetStudentReportColumns",

//Student Delete APi
DELETE_STUDENT_DATA:"SchoolDashboard/DeleteStudentData",
CHECK_STUDENT_MARKS_EXIST:"SchoolDashboard/CheckStudentMarksExist",

//Finance Report
GET_FINANCE_REPORT:"Reports/GetTodayEarningExpenseSummary",

//DiscountStudentList
GET_DISCOUNTSTUDENTLIST:"Reports/GetDiscountedStudentsList",
GET_STUDENTDISCOUNTTYPELIST:"Reports/GetStudentDiscountDetails",

GET_PARENT_IN_STUDENT:"Student/GetParentInStudentByName",


GET_RECEIPTS_DOWNLOAD:"FeeManagement/FeeCollection/GetFeeTransactionReport",

  SAVE_WHATS_APP_TEMPLATE: "AdminDashboard/SaveWhatsAppTemplate",
  UPDATE_WHATS_APP_TEMPLATE: "AdminDashboard/SaveWhatsAppTemplate",
  GET_WHATS_APP_TEMPLATE_LIST: "AdminDashboard/GetWhatsUpTemplateList",
  GET_WHATS_APP_VALUE_SOURCE_LIST: "AdminDashboard/GetWhatsAppValueSourceList",
  SCHOOL_WHATS_APP_TEMPLATE_TOGGLE: "SchoolDashboard/SchoolWhatsAppTemplateToggle",
  INSERT_UPDATE_WHATS_APP_MESSAGE_SETTING: "AdminDashboard/SaveWhatsAppMessageSetting",
  GET_ALL_WHATS_APP_MESSAGE_SETTING: "AdminDashboard/GetAllWhatsAppMessageSettings",
  DELETE_WHATS_APP_TEMPLATE: "AdminDashboard/DeleteWhatsAppTemplate",

  INSERT_TRANSFER_STUDENT_SCHOOL: "Student/TransferStudentSchool",
  TRANSFER_WALLET: "FeeManagement/FeeCollection/TransferWallet",

  //Birthday Card APi

  GET_BIRTHDAY_LIST:"AdminDashboard/GetBirthdayList",
  GET_BIRTHDAY_MESSAGE_LIST:"AdminDashboard/GetLoginBirthdayMessage",

  //create Admit Card apis

  INSERT_UPDATE_DELETE_ADMIT_CARD:"SchoolDashboard/ManageSchedule",
GET_ADMIT_CARD_SCHEDULE:"SchoolDashboard/GetSchedule",
MANAGE_INSTRUCTIONS_IN_ADMITCARD:"SchoolDashboard/ManageInstructions",
GET_INSTRUCTIONS_IN_ADMITCARD:"SchoolDashboard/GetInstructions",

//DownloadAdmitCard apis
GET_ADMIT_CARD_EXAMLIST:"Reports/GetAdmitCardExamList",
GET_ADMIT_CARD_DATA:"Reports/GetAdmitCardData",
// edit fees apis 
UPDATE_MULTIPLE_FEE_COLLECTION_APIURL: "FeeManagement/FeeCollection/UpdateMultiple",
VERIFY_ADMIN_PASSWORD: 'SchoolDashboard/VerifyAdminPassword',

// Get gender data admin dashboard
GET_STUDENT_DISTRIBUTION: 'Reports/GetStudentDistribution',

//Student admit card
 GET_STUDENT_ADMIT_CARD:"Reports/GetMyAdmitCard",
 
  GET_TRANSFERRED_STUDENTS_BY_SCHOOL: "Student/GetTransferredStudentsBySchool",
  // API_URLS mein add karo
GET_TEACHER_ATTENDANCE_PUNCH_REPORT: 'Reports/GetTeacherAttendancePunchReport',

  DOWNLOAD_ADMITCARD:"Reports/GetAdmitCardDataForDownload",
GET_ADMIT_CARD_LIST: "Reports/GetAdmitCardListForStudent",
GET_Exam_TimeTable_LIST: "Reports/GetExamListForStudent",
  GET_PUBLISHED_STUDENT_REPORT_CARD: "ReportCard/GetPublishedStudentReportCard",
  GET_PUBLISHED_EXAM_LIST_FOR_STUDENT: "Reports/GetPublishedExamListForStudent",

  GET_CERTIFICATE_TEMPLATES: "Certificate/templates",
UPDATE_CERTIFICATE_TITLE: "Certificate/title",
GET_CERTIFICATE_PRINT_DATA: "Certificate/print-data",
  ISSUE_CERTIFICATE: "Certificate/issue",
  GET_MY_CERTIFICATES: "Certificate/my-certificates",


// Whatsapp Template
GET_WHATSUP_TEMPLATE_LIST: "AdminDashboard/GetWhatsUpTemplateList",

//delete staff api
DELETE_STAFF_DATA:"EmployeeManage/DeleteStaff",
GET_STAFF_DELETION_IMPACT:"EmployeeManage/GetStaffDeletionImpact",
MANAGE_STAFF_STATUS:"EmployeeManage/ManageStaffStatus",



INSERT_UPDATE_RECEIVE_PETTY_CASH:"Expense/ManageReceivePettyCash",
  GET_RECEIVE_PETTY_CASH:"Expense/GetReceivePettyCash",
  DELETE_RECEIVE_PETTY_CASH:"Expense/DeleteReceivePettyCash",
  GET_LEDGER_SUMMERY:"Expense/GetLedgerSummery",
  GET_EXPENSE_BY_HEAD:"Expense/GetExpenseByHead",
  GET_PETTY_CASH_DASHBOARD:"Expense/GetDashboardCards",
  GET_CASH_CLOSINGBYALLDATE:"Expense/GetCashClosingByAllDate",
  INSERT_MANAGECASHCLOSING:"Expense/ManageCashClosing",
  GET_PETTYCASH_BALANCE:"Expense/GetPettyCashBalance",
  GET_PETTYCASH_RECEIVED_BY_LIST:"Expense/GetPettyCashReceivedByList",
  GET_PETTYCASH_REPORT_LIST:"Expense/GetCashReportList",

  //download Exam timetable 
  DOWNLOAD_EXAM_TIMETABLE:"Reports/GetExamTimetableGrid",
  
  // Bulk Exam Marks Upload
  BULKEXAMMARKSEXCELDOWNLOAD:"Reports/BulkExamMarksExcelDownload",
  BULKEXAMMARKSEXCELUPLOAD:"Reports/BulkExamMarksExcelUpload",
  BULKCOSCHOLASTICMARKSEXCELDOWNLOAD:"Reports/BulkCoScholasticMarksExcelDownload",
  BULKCOSCHOLASTICMARKSEXCElUPLOAD:"Reports/BulkCoScholasticMarksExcelUpload",
  
  //Student INactive /active
  MANAGE_STUDENT_STATUS:"Student/ManageStudentStatus",

  GET_EXAM_RESULT_REPORT_BY_EXAM: 'Reports/GetExamResultReportByExam',


  
GET_ALL_USERINFO_FEE_DECISION_STUDENT: "SchoolDashboard/GetStudentFeeStructureDecision",
INSERT_UPDATE_FEE_DECISION_STUDENT : "SchoolDashboard/StudentFeeStructureDecision",

  GET_SUBJECTS_MAPPING_BY_CLASS_STREAM_SUBSTREAM: "ClassSection/GetSubjectsMappingByClassStreamSubStream",
  SAVE_STUDENT_SUBJECT_MAPPING: "ClassSection/SaveStudentSubjectMapping",
  GET_CLASS_STUDENT_SUBJECT_MAPPING: "ClassSection/GetClassStudentSubjectMapping",
  GET_MARKSHEET_FIELDS: "Reports/GetMarksheetFields",
  ADD_OR_UPDATE_MARKSHEET_SETTING: "Reports/AddOrUpdateMarksheetSetting",
  GET_MARKSHEET_SETTINGS: "Reports/GetMarksheetSettings",
  SAVE_EXAM_MARKSHEET_SETTING: "Reports/SaveExamMarksheetSetting",
  GET_EXAM_MARKSHEET_SETTING: "Reports/GetExamMarksheetSetting",
  GET_ALL_RESULT_FORMAT: "Reports/GetAllResultFormat",

  //Two Factor Authentication All logins
 TWO_STEP_AUTHENTICATION_REQUEST_ADMIN: 'User/admin/2fa/request-toggle',
 TWO_STEP_AUTHENTICATION_CONFIRM_ADMIN: 'User/admin/2fa/confirm-toggle',
 TWO_STEP_AUTHENTICATION_REQUEST_EMPLOYEE: 'User/employee/2fa/request-toggle',
 TWO_STEP_AUTHENTICATION_CONFIRM_EMPLOYEE: 'User/employee/2fa/confirm-toggle',
 TWO_STEP_AUTHENTICATION_REQUEST_PARENT: 'User/parent/2fa/request-toggle',
 TWO_STEP_AUTHENTICATION_CONFIRM_PARENT: 'User/parent/2fa/confirm-toggle',
 TWO_STEP_AUTHENTICATION_REQUEST_STUDENT: 'User/student/2fa/request-toggle',
 TWO_STEP_AUTHENTICATION_CONFIRM_STUDENT: 'User/student/2fa/confirm-toggle',

 //2FA OTP Verification
 TWO_STEP_AUTHENTICATION_OTP_VERIFY_STUDENT: 'User/student-verify-login-otp',
 TWO_STEP_AUTHENTICATION_OTP_VERIFY_PARENT: 'User/parent-verify-login-otp',
 TWO_STEP_AUTHENTICATION_OTP_VERIFY_EMPLOYEE: 'User/employee-verify-login-otp',
 TWO_STEP_AUTHENTICATION_OTP_VERIFY_ADMIN: 'User/admin-verify-login-otp',

GET_STUDENT_TRIP_LIST: 'TransportManage/StudentTripList',
GET_FEE_COLLECTED_SHCEDULE_STATUS : "FeeManagement/FeeCollection/GetCollectedFeeSchedule",

  GET_MARKSHEET_HEADER_FIELDS: "Reports/GetMarksheetHeaderFields",
  ADD_OR_UPDATE_MARKSHEET_HEADER_FIELDS: "Reports/AddOrUpdateMarksheetHeaderFields",
  GET_MARKSHEET_HEADER_FIELDS_SETTING: "Reports/GetMarksheetHeaderFieldsSetting",


  // dynamic in student list header
  GET_STUDENT_LIST_HEADER_FIELDS: "Student/student-list-headers",
  ADD_OR_UPDATE_STUDENT_LIST_HEADER_FIELDS: "Student/save-student-list-headers",
  AdminResetExpiredPassword: "User/admin-reset-expired-password",
  AdminResetExpiredPasswordOTP: "User/admin-reset-expired-password-otp",

  // Chat
  CHAT_ME: "Chat/me",
  CHAT_USERS: "Chat/users",
  CHAT_CONVERSATIONS: "Chat/conversations",
  CHAT_UNREAD_COUNT: "Chat/unread-count",
  CHAT_FILTERS: "Chat/filters",
  CHAT_BROADCAST: "Chat/broadcast",
  CHAT_BROADCAST_COUNT: "Chat/broadcast/count",
  CHAT_GROUPS: "Chat/groups",
  CHAT_HOUSES: "Chat/houses",
  GET_RESULT_FIELD: "Reports/GetResultFields",
  ADD_OR_UPDATE_RESULT_SETTING: "Reports/AddOrUpdateResultSetting",
  GET_RESULT_SETTINGS: "Reports/GetResultSettings",

  // Manual Subject
  TOGGLE_MANUAL_SUBJECT_FLAG: "ClassSection/ToggleManualSubjectFlag",
  GET_MANUAL_SUBJECT_FLAG: "ClassSection/GetManualSubjectFlag",
};